module.exports = __webpack_public_path__ + "img/search2.9d9b085f.svg";